import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Payment } from 'src/features/payments/utils/types';

const RESOURCE = '/payments/payment/:paymentId/';

type QueryFnType = typeof queryFn;

interface DTO {
    paymentId: string;
}
const queryFn = ({ paymentId }: DTO): Promise<Payment> => {
    return axios.get(formatResourcePath(RESOURCE, { paymentId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPayment, RESOURCE as PAYMENT_RESOURCE };
